import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    console.log('AuthGuard checking if user is logged in...');
    const isLoggedIn = this.authService.isLoggedIn();
    console.log('User is logged in:', isLoggedIn);
    console.log('Access token:', localStorage.getItem('access_token') ? 'exists' : 'missing');
    
    if (isLoggedIn) {
      return true;
    }
    
    console.log('User is not logged in, redirecting to login');
    // Redirect to login component which will handle Microsoft auth
    this.router.navigate(['/login']);
    return false;
  }
} 